import { useQueries } from '@tanstack/react-query';

import { assetKeys } from '@/shared/lib/query/queryKeys';

import { fetchSchemaTablesCount } from '@/features/asset-detail/api';

export const useSchemaTablesCount = (schemaFqns: string[]) => {
  const queries = useQueries({
    queries: schemaFqns.map((fqn) => ({
      queryKey: assetKeys.schemaTablesCount(fqn),
      queryFn: () => fetchSchemaTablesCount(fqn),
      staleTime: 5 * 60 * 1000,
      retry: 1,
    })),
  });

  const countsMap = new Map<string, number>();
  const errorsMap = new Map<string, boolean>();
  const isLoading = queries.some((q) => q.isLoading);
  const hasError = queries.some((q) => q.isError);

  queries.forEach((query, index) => {
    const fqn = schemaFqns[index];
    if (query.data !== undefined) {
      countsMap.set(fqn, query.data);
    }
    if (query.isError) {
      errorsMap.set(fqn, true);
    }
  });

  return {
    countsMap,
    errorsMap,
    isLoading,
    hasError,
  };
};
